import { Component,OnInit,OnDestroy,AfterViewInit } from '@angular/core';
import { NgbModal,NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { takeWhile } from "rxjs/operators";

import {
    FvmsCommonService
    ,FvmsApiAuthService
    ,FvmsApiCompanyService
} from "src/app/shared/service";
import {
    DtgListType
    ,DtgActionType
} from "src/app/shared/vo";

import { DtgManageCompanyTreeComponent } from "src/app/dtg/manage/company/tree/dtg.manage.company.tree.component";
import { DtgManageCompanyFormComponent } from "src/app/dtg/manage/company/form/dtg.manage.company.form.component";

@Component({
    templateUrl: './dtg.manage.company.main.component.html'
    ,styleUrls: ["./dtg.manage.company.main.component.scss"]
    ,providers: []
})
export class  DtgManageCompanyMainComponent implements OnInit,OnDestroy,AfterViewInit {
    isContinue:boolean = true;
    companyInfo:any;
    DtgListType = DtgListType;
    DtgActionType = DtgActionType;
    loginUserInfo:any;
    treeRootCompanyInfo:any;

    constructor(
        private modalService: NgbModal
        ,private fvmsCommonService:FvmsCommonService
        ,private fvmsApiAuthService:FvmsApiAuthService
        ,private fvmsApiCompanyService:FvmsApiCompanyService
    ) {

     }

    ngOnInit() {
        this.companyInfo = this.fvmsCommonService.getCompanyInfo();
        this.loginUserInfo = this.fvmsApiAuthService.getLoginUserInfo();
        let userCompanyId = this.loginUserInfo.companyId;
        this.getOneCompanyInfoForTreeRoot(userCompanyId);

        this.fvmsApiCompanyService.subscribeCompanyEvent()
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(companyEvent => {
                if(companyEvent){
                    let actionType = companyEvent.DtgActionType;
                    let currCompanyInfo = companyEvent.companyInfo;
                    // console.log("currentCompanyInfo",currentCompanyInfo);
                    switch(actionType){
                        case DtgActionType.ok:
                        case DtgActionType.cancel:
                            this.getOneCompanyInfoForTreeRootReload(userCompanyId);
                            break;
                        case DtgActionType.delete:
                            this.getOneCompanyInfoForTreeRoot(userCompanyId);
                            break;
                        default:
                            break;
                    }
                }
            });
    }

    ngOnDestroy() {
        this.isContinue = false;
    }

    ngAfterViewInit() {

    }

    getOneCompanyInfoForTreeRoot(userCompanyId:number){
        this.fvmsApiCompanyService.getOneCompanyTree(userCompanyId)
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(response => {
                if(response.resultStatus === "ok"){
                    this.treeRootCompanyInfo = response.resultValue;
                    let companyEvent = {
                        companyInfo:this.treeRootCompanyInfo
                        ,DtgActionType:DtgActionType.update
                    };
                    this.fvmsApiCompanyService.setCompanyEvent(companyEvent);
                }
            });
    }

    getOneCompanyInfoForTreeRootReload(userCompanyId:number){
        this.fvmsApiCompanyService.getOneCompanyTree(userCompanyId)
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(response => {
                if(response.resultStatus === "ok"){
                    this.treeRootCompanyInfo = response.resultValue;
                }
            });
    }
}
